export const getTypeformIdFromUrl = (formUrl: any) => {
  // get Typeform ID from URL using regex
  // Previous regex was not safari compliant (look behind not supported) be mindfull when changing that
  return formUrl ? formUrl.match(/typeform\.com\/to\/([a-zA-Z0-9]+)/)?.[1] : '';
};

export const isTypeformUrl = (formUrl: any) => {
  return Boolean(getTypeformIdFromUrl(formUrl));
};

export default {
  getTypeformIdFromUrl,
  isTypeformUrl,
};
